import {showPurchaseCreditsDialog} from '@Libraries/ai-chat.library';
import {refreshTeamCreditsInStore} from '@Components/team-credits/team-credits-library';

/** Fire-and-forget so the caller never waits on a checkout the user can close without buying. */
export const openCreditPackCheckout = (): void => {
  void showPurchaseCreditsDialog().then((purchaseData) => {
    if (!purchaseData?.creditsV2) {
      return;
    }

    void refreshTeamCreditsInStore();
  });
};
